import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ProductVariantDetailComponent } from '@vendure/admin-ui/catalog';
import {
  CustomDetailComponent,
  NotificationService,
  SharedModule,
} from '@vendure/admin-ui/core';
import { Product } from '@vendure/core';
import {
  Observable,
  asapScheduler,
  distinctUntilChanged,
  filter,
  pairwise,
  scheduled,
} from 'rxjs';

@Component({
  template: ``,
  standalone: true,
  providers: [],
  imports: [SharedModule],
})
export class ProductVariantDetailFormListenerComponent
  implements CustomDetailComponent
{
  entity$!: Observable<Product>;

  private readonly productVariantDetailComponent = inject(
    ProductVariantDetailComponent,
  );

  detailForm = this.productVariantDetailComponent.detailForm;

  constructor() {
    const notificationService = inject(NotificationService);

    const skuChangedDueToSave$ = scheduled(
      this.detailForm.controls.sku.valueChanges.pipe(distinctUntilChanged()),
      asapScheduler,
    ).pipe(
      pairwise(),
      filter(
        ([oldVal, newVal]) => this.detailForm.pristine && oldVal !== newVal,
      ),
    );

    skuChangedDueToSave$
      .pipe(takeUntilDestroyed())
      .subscribe(([inputSku, updatedSku]) => {
        notificationService.warning(
          `SKU ${inputSku} not unique! Changed to ${updatedSku}`,
        );
      });
  }
}
